import gql from "graphql-tag"

export const IS_DOMAIN_SUPPRESSED = gql`
  query IsDomainSuppressed($domain: String!) {
	  isDomainSuppressed(domain: $domain)
  }
`;
